
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.97 3.528a1.267 1.267 0 012.06 0l3.317 4.663 2.2-3.126a1.777 1.777 0 012.906 0l6.613 9.397C32.664 20.996 27.99 30 20 30c-5.57 0-9.528-4.375-9.857-9.24-4.48-1.191-6.74-6.597-3.858-10.647l4.686-6.585zm1.245.58l4.685 6.585C19.675 14.591 16.87 20 12 20s-7.675-5.408-4.9-9.307l4.685-6.585a.267.267 0 01.43 0zm-1.052 16.845C11.577 25.22 15.093 29 20 29c7.18 0 11.38-8.091 7.248-13.963L20.635 5.64a.777.777 0 00-1.27 0l-2.403 3.415.753 1.058C20.973 14.69 17.66 21 12 21c-.285 0-.564-.016-.837-.047z","fill":"#000"}})])
          )
        }
      }
    